import useAnalysis from "./useAnalysis"
import SectionSelector from "./components/SectionSelector/SectionSelector"
import ControlSelector from "./components/ControlSelector/ControlSelector"
import AnalysisControls from "./components/AnalysisControls/AnalysisControls"
import ErrorBanner from "../../components/ErrorBanner/ErrorBanner"
import WorkflowInfoSection from "./components/WorflowInfoSection/WorkflowInfoSection"
import ScanMediaSection from "./components/ScanMediaSection/ScanMediaSection"
import useReportControls from "./components/ReportControls/useReportControls"
import ReportControls from "./components/ReportControls/ReportControls"
import { ToastContainer } from "react-toastify"
import PrimaryDataSection from "./components/PrimaryDataSection/PrimaryDataSection"
import AnalysisDecisionSection from "./components/AnalysisDecisionSction/AnalysisDecisionSection"
import AnalysisTitleBar from "./components/AnalysisTitleBar/AnalysisTitleBar"
import "./Analysis.css"

const AnalysisDashboard = () => {

  const [{
    workflow,
    isolatedScans,
    dataDisplayOptions,
    graphRef,
    selectedSection,
    selectedControl,
    analysisControls,
    isDownloadingReport,
    reportError,
    getProcessingVersion,
    sections,
    sectionImages,
    workflowInfoForm,
    workflowOverview,
    disableAreaOfInterest,
    onSelectControl,
    onSelectSection,
    onDownloadReport,
    onHideReportError,
    onBack
  }] = useAnalysis()

  const [{
    showTHzHeatmapCheckbox,
    showThermalHeatmapCheckbox,
    showMetalHeatamapCheckbox,
    showScanCommentsCheckbox,
    showVoiceNotesCheckbox,
    showScanImagesCheckbox,
  }] = useReportControls()
  
  const analysisControlComponents = [
    <AnalysisControls 
      overlayCheckbox={analysisControls.overlayAnalysisCheckbox}
      disableOverlayCheckbox={disableAreaOfInterest()}
      showMinCheckbox={analysisControls.minHighlightCheckbox}
      showMaxCheckbox={analysisControls.maxHighlightCheckbox}
      dataDisplayOptions={dataDisplayOptions.map(option => option.title)}
      selectedDisplay={analysisControls.selectedDisplayOption.value}
      onClickDataDisplayOption={analysisControls.selectedDisplayOption.onChange}
      scanHeightDropdown={analysisControls.scanHeightDropdown}
      getProcessingVersion={getProcessingVersion}
    />,

    <ReportControls
      showTHzHeatmapCheckbox={showTHzHeatmapCheckbox}
      showThermalHeatmapCheckbox={showThermalHeatmapCheckbox}
      showMetalHeatmapCheckbox={showMetalHeatamapCheckbox}
      showScanCommentsCheckbox={showScanCommentsCheckbox}
      showVoiceNotesCheckbox={showVoiceNotesCheckbox}
      showScanImagesCheckbox={showScanImagesCheckbox}
      isDownloadingReport={isDownloadingReport}
      onGenerateReport={onDownloadReport}
    />
  ]

  return (
    <div className="analysis-container">
      <ErrorBanner
        show={reportError !== undefined}
        error={reportError ?? new Error("Failed to fetch.")}
        onClose={onHideReportError}
      />

      <AnalysisTitleBar workflow={workflow} onBack={onBack} />

      <SectionSelector
        sectionMetadata={isolatedScans}
        sections={sections} 
        selectedSection={selectedSection} 
        onSelect={onSelectSection}
      />
      
      <div className="analysis-control-container">
        <div className="analysis-display">

          <WorkflowInfoSection {...workflowInfoForm} />

          <AnalysisDecisionSection {...workflowOverview} />

          <PrimaryDataSection {...dataDisplayOptions[analysisControls.selectedDisplayOption.value]} />

          <ScanMediaSection 
            media={sectionImages}
          />

          <div className="analysis-section" style={{opacity: 0}}>
            <p ref={graphRef}>Subtera</p>
          </div>
        </div>
        
        <div className="controls-container">
          <ControlSelector
            options={["Analysis", "Report"]}
            selected={selectedControl}
            onSelect={(i) => onSelectControl(i)}
          />

        <div className="analysis-controls">
          {analysisControlComponents[selectedControl]}
        </div> 
        </div>
      </div>
     
      <ToastContainer />
      {/* <ExpiredTokenAlert show={showSignedOut} onConfirm={onConfirmSignedOut} /> */}
    </div>
  )
}

export default AnalysisDashboard
